module.exports = __webpack_public_path__ + "static/bg.f05fff89.jpg";